const forbiddenTemplateUrl = require('./forbidden.html');

module.exports = function($stateProvider) {
  $stateProvider.state('forbidden', {
    templateUrl: forbiddenTemplateUrl
  });
};

module.exports.$inject = ['$stateProvider'];
